<h1>Move Lead <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>


<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-12">
        <form [formGroup]="moveLeadForm" (submit)="submitLead()">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Name *</label>
                        <input type="text" formControlName="name" class="form-control" readonly />
                    </div>
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Mobile *</label>
                        <input type="text" formControlName="mobile" class="form-control" readonly />
                    </div>

                    <div class="col-sm-6 mt-5">
                        <div class="form-group">
                            <label class="form-label">Treatment *</label>
                            <mat-select placeholder="Select Treatment" formControlName="treatment_id"
                                (click)="setSearchValue('treatment')">
                                <input class="mySearchInput" #treatmentSearch focused="'true'" type="text"
                                    (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                    (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                    id="treatmentSearch">
                                <mat-option [value]="treatment.id" *ngFor="let treatment of treatments">
                                    {{treatment.name}}</mat-option>
                            </mat-select>
                            <div *ngIf="submitted && f.treatment_id.errors" class="invalid-feedback">
                                <div *ngIf="f.treatment_id.errors.required">Treatment is required</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <div class="form-group">
                            <label class="form-label">Lead Owner *</label>
                            <mat-select placeholder="Select Lead Owner" [disabled]="lead_bd" formControlName="user_id"
                                (click)="setSearchValue('lead_owner')">
                                <input class="mySearchInput" #ownerSearch focused="'true'" type="text"
                                    (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                    (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                    id="ownerSearch">
                                <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                            <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                                <div *ngIf="f.user_id.errors.required">Lead Owner is required</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="card-footer">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                        class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>
</div>